import { css } from '@emotion/react';
import { type FC } from 'react';
import { blinkLoaderStyle } from '~/_shared/components/loader/blinkLoader.styles';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { type ThemeProps } from '~/_shared/types/themeProps';

type BoundaryGroupsListingItemSkeletonProps = Readonly<{
  animationDurationMs: number;
  animationDelayMs: number;
}>;

const wrapperStyle = ({ theme }: ThemeProps) => css({
  display: 'flex',
  alignItems: 'center',
  background: theme.backgroundColors.secondary,
  borderTop: `1px solid ${theme.borderColors.primary}`,
  justifyContent: 'space-between',
  padding: '5px 14px 3px',
  '&:first-of-type': {
    borderTop: 'none',
  },
});

const headingPrimaryBarStyle = ({ theme }: ThemeProps) => css({
  width: 280,
  height: 17,
  background: theme.backgroundColors.primary,
  borderRadius: 4,
});

const headingSecondaryStyle = ({ theme }: ThemeProps) => css({
  width: 76,
  height: 11,
  background: theme.backgroundColors.primary,
  borderRadius: 4,
  marginTop: 3,
});

const ctaBarStyle = ({ theme }: ThemeProps) => css({
  width: 86,
  height: 25,
  background: theme.backgroundColors.primary,
  borderRadius: 4,
});

export const BoundaryGroupsListingItemSkeletonComponent: FC<BoundaryGroupsListingItemSkeletonProps> = (props) => {
  const theme = useTheme();

  return (
    <div css={wrapperStyle({ theme })}>
      <div>
        <div css={[headingPrimaryBarStyle({ theme }), blinkLoaderStyle(props.animationDurationMs, props.animationDelayMs)]} />
        <div css={[headingSecondaryStyle({ theme }), blinkLoaderStyle(props.animationDurationMs, props.animationDelayMs)]} />
      </div>

      <div css={[ctaBarStyle({ theme }), blinkLoaderStyle(props.animationDurationMs, props.animationDelayMs)]} />
    </div>
  );
};
